import { faArrowsRotate, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/base/Button";
import axiosInstance from "helpers/api";
import { useAtom } from "jotai";
import { dealsAtom } from "jotai/LeadsJotaiInstance";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import axios from "axios";

interface LeadType {
  id: string;
  lead_type: string;
  category?: string;
  description?: string;
}

interface FilterDealsModalProps {
  show: boolean;
  handleClose: () => void;
}

type Inputs = {
  lead_types_id: string;
};

const FilterDealsModal = ({ show, handleClose }: FilterDealsModalProps) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const [, setDeals] = useAtom(dealsAtom);
  const [leadTypes, setLeadTypes] = useState<LeadType[]>([]);
  const fetchLeadTypes = async () => {
    try {
      const response = await axiosInstance.get("/leads/types");
      setLeadTypes(response?.data?.data.leadTypes);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error(error.response?.data?.message || error.message);
      } else {
        console.error(error instanceof Error ? error.message : 'Unknown error occurred');
      }
    }
  };

  useEffect(() => {
    fetchLeadTypes();
  }, []);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      const response = await axiosInstance.get("/deals", {
        params: {
          lead_types_id: data.lead_types_id,
        },
      });
      setDeals(response.data.data);
      handleClose();
    } catch (error) {
      if (axios.isAxiosError(error)) {
        toast.error(error.response?.data?.message || 'An error occurred');
      } else {
        toast.error('An error occurred while filtering deals');
      }
    }
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      className="p-0"
      centered
      contentClassName="border"
    >
      <Modal.Header className="border-translucent p-4">
        <h5 className="modal-title text-body-highlight fs-6 lh-sm">Filter</h5>
        <Button className="p-1 ms-auto" onClick={handleClose}>
          <FontAwesomeIcon icon={faTimes} className="fs-9 text-danger" />
        </Button>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body className="pt-4 pb-2 px-4">
          <div className="mb-3">
            <Form.Group>
              <Form.Label>Lead Type</Form.Label>
              <Form.Select
                {...register("lead_types_id", {
                  required: true,
                  maxLength: 100,
                })}
              >
                <option value="" selected disabled>
                  Select Lead Type
                </option>
                {leadTypes.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.lead_type}
                  </option>
                ))}
              </Form.Select>
              {errors.lead_types_id?.type === "required" && (
                <p role="alert" className="text-danger fs-9 pt-1 mb-0">
                  First name is required
                </p>
              )}
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end align-items-center px-4 pb-4 border-0 pt-3">
          <Button
            variant="phoenix-primary"
            size="sm"
            className="px-4 fs-10 my-0"
            startIcon={
              <FontAwesomeIcon icon={faArrowsRotate} className="me-2 fs-10" />
            }
          >
            Reset
          </Button>
          <Button
            variant="primary"
            size="sm"
            className="px-9 fs-9 my-0"
            type="submit"
          >
            Done
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default FilterDealsModal;
